import { render, staticRenderFns } from "./UploadGrid.vue?vue&type=template&id=50dbbca6"
import script from "./UploadGrid.vue?vue&type=script&lang=js"
export * from "./UploadGrid.vue?vue&type=script&lang=js"
import style0 from "./UploadGrid.vue?vue&type=style&index=0&id=50dbbca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports